<span id="entity-modal-label" class="sr-only">{{ (currentLang === 'he' ? (modelDetails?.modelNameHebrew || modelDetails?.modelNameEnglish) : (modelDetails?.modelNameEnglish || modelDetails?.modelNameHebrew)) || (('iaa.app.excavation.model' | translate) + ' ' + modelId) }}</span>
<app-entity-page
  [closeClicked]="closeClicked"
  [switchToMapTab]="switchToMapTab"
  [detailsContentTitle]="(currentLang === 'he' ? (modelDetails?.modelNameHebrew || modelDetails?.modelNameEnglish) : (modelDetails?.modelNameEnglish || modelDetails?.modelNameHebrew)) || (('iaa.app.excavation.model' | translate) + ' ' + modelId)"
  [mapContentTitle]="'iaa.general.map' | translate"
  [loading]="isLoading">
  <ng-template #detailsContent>
    <div class="model-content">

      <div class="model-viewer-container" *ngIf="safeModelUrl && !error; else errorContent">
        <iframe
          [src]="safeModelUrl"
          class="model-iframe"
          allowfullscreen
          [title]="(currentLang === 'he' ? (modelDetails?.modelNameHebrew || modelDetails?.modelNameEnglish) : (modelDetails?.modelNameEnglish || modelDetails?.modelNameHebrew)) || ('iaa.app.excavation.model' | translate)"
          allow="orientation-lock; fullscreen *">
        </iframe>
      </div>

      <ng-template #errorContent>
        <div class="error-container">
          <p class="error-message">{{ (error || 'iaa.general.error') | translate }}</p>
        </div>
      </ng-template>

      <div class="model-details" *ngIf="modelDetails && !error">

        <div class="detail-item" *ngIf="modelDetails.source">
          <label class="detail-label">{{'iaa.app.model.modelType' | translate}}</label>
          <div class="detail-value">{{ 'iaa.app.model.sourceType.' + modelDetails.source | translate }}</div>
        </div>

        <div class="detail-item" *ngIf="modelDetails.detectedDate">
          <label class="detail-label">{{'iaa.general.date' | translate}}</label>
          <div class="detail-value">{{ modelDetails.detectedDate }}</div>
        </div>

        <div class="detail-actions" *ngIf="modelDetails.downloadUrl">
          <p-button
            styleClass="icon-button"
            [ngClass]="{'icon-button': true, 'en': currentLang === 'en'}"
            [link]="true"
            icon="pi pi-download"
            [label]="'iaa.aria.btnDownloadModel' | translate"
            [tabindex]="0"
            [ariaLabel]="'iaa.aria.btnDownloadModel' | translate"
            (click)="downloadModel()"
            (keydown.enter)="downloadModel()">
          </p-button>
        </div>

      </div>
    </div>
  </ng-template>

  <ng-template #mapContent>
    <div class="model-map">
      <app-arcgis-map #modelMap
        [shapes]="shapes"
        [mapControls]="mapControls"
        [extentAll]="true"
        [popupEnabled]="true"
        [lang]="currentLang"
        [selectedEntityId]="selectedEntityId"
        [cogAboveShapes]="true"
        (viewReady)="onMapReady(modelMap)">
      </app-arcgis-map>
    </div>
  </ng-template>

</app-entity-page>


